import UploadingProgressionView from './UploadingProgressionView';

export default UploadingProgressionView;